import { render, staticRenderFns } from "./notYetImplemented.vue?vue&type=template&id=506b8a91&"
import script from "./notYetImplemented.vue?vue&type=script&lang=js&"
export * from "./notYetImplemented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports